import Body from '@service-victoria/component-library/components/Text/Body';
import { Spacer } from '@service-victoria/component-library/utils/styled';
import React from 'react';

import Page from 'Components/Page';

import * as Styled from './styled';

const NoLongerRequired: React.FC = () => {
  return (
    <Page
      banner={{
        title: 'Kiosk Check-in'
      }}>
      <Styled.Section>
        <Spacer.Large>
          <Body style={{ color: '#0052c2' }}>
            From 11.59pm Friday 22 April 2022 you no longer need to check in anywhere in Victoria.
          </Body>
        </Spacer.Large>
      </Styled.Section>
    </Page>
  );
};

export default NoLongerRequired;
